import { Box, useToast, Image, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import ProgressHeader from '../../../components/V2/Homepage/ProgressHeader';
import ProgressBody from '../../../components/V2/Homepage/ProgressBody';
import ProgressFooter from '../../../components/V2/Homepage/ProgressFooter';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import { UIErrorResponse } from '../../../../../../packages/types/src/error';
import * as yup from 'yup';

import { SignUpFormInputs } from '../../../components/V2/Homepage/Onboarding/SignupForm';
import { AxiosError } from 'axios';
import { ErrorResponse } from '../../../components/Auth/SignUpForm';
import { signUp, updateUserProfile, verifySignUpOtp } from '../../../apis/V2/auth';
import { useDomainConfig } from '../../../hooks/useDomainConfig';
import { useUser } from '../../../hooks/useUser';
import { useUserProfile } from '../../../hooks/V2/useUser';
import { Course } from '../../../components/V2/Homepage/Onboarding/AspireCareer';
import { enrolInCourses } from '../../../apis/V2/course';
import { useLocation, useNavigate } from 'react-router-dom';
import ModalTemplateV2 from '../../../components/common/ModalTemplateV2';
import { yupResolver } from '@hookform/resolvers/yup';
import { emailRegex, nameRegex, phoneRegex } from '../../../components/V2/Homepage/Onboarding/SignInForm';
import { useVerifyExternalToken } from '../../../hooks/useVerifyExternalToken';
import { SAGEX_ORG_KEY } from '../../../utils/segexOrgName';

const Homepage = () => {
	// Verify external token
	const location = useLocation();
	// Parse the query parameters to get the token
	const queryParams = new URLSearchParams(location.search);
	const token = queryParams.get('token');
	// Use the useVerifyExternalToken hook
	const { data, error } = useVerifyExternalToken(token || '');
	const [otp, setOtp] = useState<string>('');
	const { data: domainConfig } = useDomainConfig({ uiHost: window.location.host });
	const [currentStep, setCurrentStep] = useState(1);
	const [showOtpUi, setShowOtpUi] = useState(false);
	const { data: user, refetch: refetchUser } = useUser();
	const { data: userProfile, refetch: refetchUserProfile } = useUserProfile();
	const [selectedCourses, setSelectedCourses] = useState<Course[]>([]);
	const [selectedDomain, setSelectedDomain] = useState('');
	const [selectedCourse, setSelectedCourse] = useState('');
	const [selectedSpec, setSelectedSpec] = useState('');
	const [selectedYear, setSelectedYear] = useState('');

	const [jobSelect, setJobSelect] = useState<string>('');

	const schema = yup.object({
		name: yup.string().min(2, 'Name must be at least 2 characters').matches(nameRegex, 'Please enter a valid name'),
		phoneNumber: yup
			.string()
			.matches(phoneRegex, 'Please Enter a valid Phone number')
			.test('no_country_code', 'Phone number should not contain +91 and should be 10 digit long', value => {
				if (value) {
					// Check if the phone number contains +91
					return !value.includes('+91');
				}
				return true;
			}),
		email: yup.string().matches(emailRegex, 'Please Enter a valid Email'),
		termsCheck: yup.boolean().oneOf([true], 'Please Select the terms and conditions'),
	});

	const {
		register,
		handleSubmit,
		setValue,
		getValues,
		formState: { errors },
	} = useForm<SignUpFormInputs>({
		// @ts-ignore
		resolver: yupResolver(schema),
	});
	const toast = useToast();
	useEffect(() => {
		if (user) {
			if (window.location.href !== '/onboarding') {
				navigate('/onboarding');
			}
			setCurrentStep(2);
		}
		console.log('userProfile:', userProfile);
		if (userProfile && userProfile.degree && userProfile.branch && userProfile.graduationYear && userProfile.domain) {
			setCurrentStep(3);
		}
		if (userProfile && userProfile.jobPreference) {
			setCurrentStep(4);
		}
		console.log('userProfile----:', userProfile);
		if (userProfile && userProfile.enrolments && userProfile.enrolments.length > 0 && !showWaitingModal) {
			navigate('/dashboard');
		}
	}, [user, userProfile]);

	const { mutate: signUpMutate, isLoading: isSignUpLoading } = useMutation(signUp, {
		onSuccess: () => {
			setShowOtpUi(true);
			// toast({
			// 	title: 'Success',
			// 	description: 'Otp sent!',
			// 	status: 'success',
			// 	duration: 2000,
			// 	isClosable: true,
			// 	position: 'top',
			// });
		},

		onError: (error: AxiosError<ErrorResponse>) => {
			toast({
				title: 'Error',
				description: error?.response?.data?.message || 'User signup failed',
				status: 'error',
				duration: 2000,
				isClosable: true,
				position: 'top',
			});
		},
	});

	const { mutate: verifySignUpOtpMutate, isLoading: verifySignUpOtpLoading } = useMutation(verifySignUpOtp, {
		onSuccess: () => {
			// refetch user
			if (data) {
				updateUserProfileMutation({
					degree: 'Others',
					domain: 'Others',
					branch: 'Others',
					graduationYear: '2022',
					jobPreference: 'full-time-job',
				});
				enrolInCoursesMutate(data.courses);
				navigate('/dashboard');
			} else {
				setCurrentStep(2);
			}
			refetchUser();
			setOtp('');

			showOtpUi && setShowOtpUi(false);
			// toast({
			// 	title: 'Success',
			// 	description: 'Signed up successfully!',
			// 	status: 'success',
			// 	duration: 2000,
			// 	isClosable: true,
			// 	position: 'top',
			// });
		},
		onError: (error: AxiosError<ErrorResponse>) => {
			toast({
				title: 'Error',
				description: error?.response?.data?.message || 'Otp verification failed!',
				status: 'error',
				duration: 2000,
				isClosable: true,
				position: 'top',
			});
		},
	});
	const [showWaitingModal, setShowWaitingModal] = useState(false);
	const { mutate: updateUserProfileMutation, isLoading } = useMutation(updateUserProfile, {
		onSuccess: () => {
			refetchUserProfile();
			// toast({
			// 	title: 'Success',
			// 	description: 'Profile updated successfully!',
			// 	status: 'success',
			// 	duration: 2000,
			// 	isClosable: true,
			// 	position: 'top',
			// });
			setCurrentStep(3);
		},
		onError: (error: AxiosError<UIErrorResponse>) => {
			console.log('error:', error);
			toast({
				title: 'Error',
				description: error?.response?.data?.message || 'Profile update failed!',
				status: 'error',
				duration: 2000,
				isClosable: true,
				position: 'top',
			});
		},
	});
	const navigate = useNavigate();
	const { mutate: enrolInCoursesMutate, isLoading: enrolInCoursesMutateLoading } = useMutation(enrolInCourses, {
		onSuccess: () => {
			refetchUserProfile();
			setShowWaitingModal(true);
			setTimeout(() => {
				navigate('/dashboard');
				setShowWaitingModal(false);
			}, 3000);
			// toast({
			// 	title: 'Success',
			// 	description: 'Course enrolment done!',
			// 	status: 'success',
			// 	duration: 2000,
			// 	isClosable: true,
			// 	position: 'top',
			// });
		},
		onError: (error: AxiosError<UIErrorResponse>) => {
			toast({
				title: 'Error',
				description: error?.response?.data?.message || 'Course enrolment failed!',
				status: 'error',
				duration: 2000,
				isClosable: true,
				position: 'top',
			});
		},
	});

	useEffect(() => {
		if (domainConfig?.key === SAGEX_ORG_KEY) {
			if (data) {
				setValue('name', data.name);
				setValue('email', data.email);
				setValue('phoneNumber', data.phoneNumber);
				signUpSendOtp();
				setShowOtpUi(true);
			} else {
				window.location.href = 'http://sageextension.com/login';
			}
		}
	}, [data, domainConfig?.key, setValue, signUpMutate]);

	const signUpSendOtp = () => {
		const formData = getValues();
		signUpMutate({
			...formData,
			domainKey: domainConfig?.key,
		});
	};
	const handleSignUpSendOtp = handleSubmit(signUpSendOtp);

	useEffect(() => {
		if (enrolInCoursesMutateLoading) {
			setShowWaitingModal(true);
		}
	}, [enrolInCoursesMutateLoading]);

	const signUpVerifyOtp = () => {
		const formData = getValues();

		verifySignUpOtpMutate({
			otp,
			phoneNumber: formData.phoneNumber,
		});
		setShowOtpUi(true);
	};
	const handleSignUpVerifyOtp = handleSubmit(signUpVerifyOtp);

	const handleCollegeInfoSubmit = () => {
		updateUserProfileMutation({
			degree: selectedCourse,
			domain: selectedDomain,
			branch: selectedSpec,
			graduationYear: selectedYear,
		});
	};
	const handleJobPreferenceSubmit = () => {
		updateUserProfileMutation({
			jobPreference: jobSelect,
		});
	};
	const handleCourseEnrolremtSubmit = () => {
		console.log('selectedCourses:', selectedCourses);
		enrolInCoursesMutate(selectedCourses.map(course => course.id));
	};
	const [isSignUpChecked, setIsSignUpChecked] = useState<boolean>(false);

	useEffect(() => {
		if (otp.length === 6) {
			handleSignUpVerifyOtp();
		}
	}, [otp]);

	return (
		<>
			<Box px="16px" minH="full" display={'flex'} flexDirection={'column'}>
				<Box maxW={{ md: '618px' }} mx="auto" w="full">
					<ProgressHeader currentStep={currentStep} setCurrentStep={setCurrentStep} />
				</Box>
				<Box mt={{ base: 'auto', md: '0px' }} position={'relative'}>
					<Box mb={{ base: '88px', md: '10px' }} maxW={{ md: currentStep == 4 ? '727px' : '497px' }} mx="auto">
						<ProgressBody
							isSignUpChecked={isSignUpChecked}
							setIsSignUpChecked={setIsSignUpChecked}
							showOtpUi={showOtpUi}
							setShowOtpUi={setShowOtpUi}
							otp={otp}
							setOtp={setOtp}
							errors={errors}
							register={register}
							currentStep={currentStep}
							phoneNumber={getValues().phoneNumber}
							selectedDomain={selectedDomain}
							setSelectedDomain={setSelectedDomain}
							selectedCourse={selectedCourse}
							setSelectedCourse={setSelectedCourse}
							selectedSpec={selectedSpec}
							setSelectedSpec={setSelectedSpec}
							selectedYear={selectedYear}
							setSelectedYear={setSelectedYear}
							jobSelect={jobSelect}
							setJobSelect={setJobSelect}
							selectedCourses={selectedCourses}
							setSelectedCourses={setSelectedCourses}
							handleSignUpSendOtp={handleSignUpSendOtp}
						/>
					</Box>
					<ProgressFooter
						isLoading={isSignUpLoading || verifySignUpOtpLoading || isLoading || enrolInCoursesMutateLoading}
						showOtpUi={showOtpUi}
						currentStep={currentStep}
						setCurrentStep={setCurrentStep}
						handleFormSubmit={handleSignUpSendOtp}
						handleSignUpVerifyOtp={data ? signUpVerifyOtp : handleSignUpVerifyOtp}
						handleCollegeInfoSubmit={handleCollegeInfoSubmit}
						handleJobPreferenceSubmit={handleJobPreferenceSubmit}
						handleCourseEnrolremtSubmit={handleCourseEnrolremtSubmit}
						disabled={
							(currentStep === 4 && selectedCourses.length == 0) ||
							(currentStep === 3 && !jobSelect) ||
							(currentStep === 2 && (!selectedCourse || !selectedDomain || !selectedSpec || !selectedYear))
							// (currentStep === 1 && !isSignUpChecked)
						}
					/>
				</Box>
			</Box>

			<ModalTemplateV2
				closeOnOverlayClick={false}
				isOpen={showWaitingModal}
				onClose={() => {
					setShowWaitingModal(false);
				}}
				showConfetti={false}
				hideIconWithConfetti={true}
				// autoCloseInSeconds={30}
				extra={
					<Box>
						<Image w={{ base: '260px', md: '348px' }} h={{ base: '226px', md: '302px' }} mx="auto" src="/images/giff/waiting-gif.gif"></Image>
						<Text maxW="472px" color="#E5E5E5" textStyle={{ base: 'h6', md: 'h2' }}>
							Please wait while we are creating your dashboard
						</Text>
					</Box>
				}
			/>
		</>
	);
};

export default Homepage;
